import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import uniqBy from 'lodash/uniqBy'

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';

import Header from '@components/Header';
import ModalUpdateDocument from '@components/Anexos/ModalUpdateDocument';

import { getDigitalForms  } from '@actions/digitalForms';

import {
  AuthorizedStatus,
} from '@constants/general'


class DigitalForms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: false,
      allForms: [],
      forms: [],
      filterProcess: [],
      filterSelected: null,
      hasFileData: false,
      showModalUpdateDocument: {
        isVisible: false,
        continueAction: null,
      },
    };
  }

  async componentDidMount() {
    const { getDigitalForms } = this.props;
    this.setState({ loadingTable: true });
    const response = await getDigitalForms();
    if (!response?.status) {
      const getFilters = uniqBy(response.data, 'procesoId').map(item => ({procesoId: item.procesoId, nombreProceso: item.nombreProceso}))
      console.log('getFilters', getFilters)
      this.setState({
        allForms: response.data,
        filterProcess: getFilters,
        filterSelected: getFilters[0],
        loadingTable: false,
      });
      this.setData()
    }
    return this.setState({ loadingTable: false });
  }

  setData = () => {
    const { filterSelected, allForms } = this.state
    console.log('filterSelected', filterSelected)
    const getForm = allForms.filter(item => item.procesoId === filterSelected.procesoId)
    this.setState({ forms: getForm })
  }

  onchangeFilter = ({target}) => {
    console.log('Entra0,00', target)
    return this.setState({filterSelected: target.value}, () => this.setData())
  }

  onEditForm = (node) => {
    const { history } = this.props
    history.push( {pathname: "/digital-form/edit", state: {clearCache: true, ...node}})
  }

  columnName = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <span>
        <img src='/assets/img/icon-file.svg' className='p-mr-4' width='32' height='32'/>
        {node.nombre}
      </span>
    </div>
  );

  templateAuthorized = (node, detail) => {
    const { t } = this.props;

    if (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-grey"> {t('AUTORIZADO')} </span>
        </>
      );
    }
    if (node.estatus === AuthorizedStatus.STATUS_PENDING) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-blue"> {t('PENDIENTE')} </span>
        </>
      );
    }
    if (node.estatus === AuthorizedStatus.STATUS_EDITION) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-green"> {t('EN EDICIÓN')} </span>
        </>
      )
    }
    return (<span className="p-column-title">{detail.header}</span>);
  };

  columnAction = (node, detail) => {
    const { t } = this.props
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
        <Button
          icon="pi pi-pencil"
          label={t('Editar')}
          className="p-button-info"
          onClick={() => this.onEditForm(node)}
        />
      </div>
    )

  };

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  render() {
    const { history, t } = this.props;
    const { loadingTable, forms, showModalUpdateDocument, hasFileData, filterProcess, filterSelected } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
      </>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Formularios digitales')} rightComponent={rightHeader} />
          <div className="card p-grid">
            <div className="p-col-12 p-md-12 p-lg-4 p-d-flex p-ai-center p-jc-start">
              <label className="p-mr-2 p-text-bold">{t('Proceso')}:</label>
              <Dropdown
                name="filterSelected"
                value={filterSelected}
                options={filterProcess}
                onChange={this.onchangeFilter}
                optionLabel="nombreProceso"
                placeholder=""
                style={{ width: '100%' }}
              />
            </div>
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={forms}
                lazy
                loading={loadingTable}
                className="table-documents"
              >
                <Column
                  header={t('Nombre')}
                  body={this.columnName}
                />
                <Column
                  header={t('Estatus')}
                  body={this.templateAuthorized}
                  className="column-authorized"
                />
                <Column
                  header={t('Versión')}
                  field="defaultVersion"
                  body={this.columnResponsive}
                  className="column-authorized p-text-bold"
                />
                
                <Column
                  header={t('Acción')}
                  body={this.columnAction}
                  className="column-authorized"
                />
              </DataTable>
            </div>
          </div>
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        { showModalUpdateDocument.isVisible && (
          <ModalUpdateDocument
             nameDocument={showModalUpdateDocument.nameDocument}
              onHidden={() => this.onHideModalUpdateDocument()}
              onContinueAction={showModalUpdateDocument.continueAction}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  itemsLanguageCatalog: state.catalogs.itemsLanguageCatalog
});

const mapDispatchToProps = {
  getDigitalForms
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(DigitalForms);
